import styled from 'styled-components';

export const Backdp = styled.div`
    width:100%;
    height:100%;
    position:fixed;
    top:0;
    left:0;
    background: rgba(20,24,35,0.7);
    z-index:1;
`;

export const HourlyRentalsPop = styled.div`
    width: 673px;
    height: 651px;
    background: #fff;
    border-radius: 20px;
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    margin: auto;
    z-index: 99999;

    & .inner{
        height: 100%;
        overflow: auto;
        display:flex;
        flex-direction:column;
        padding:5rem;
    }

    & li{
        font-size: 16px;
        line-height: 22px;
        color: #141823;
        position:relative;
        margin-bottom:20px;
        padding-left:20px;
    }

    & li:before{
        content:'';
        width:6px;
        height:6px;
        border-radius:100%;
        background: #777777;
        position:absolute;
        top:7px;
        left:0px;
    }

    & h2{
            font-family: 'Rubik';
            font-style: normal;
            font-weight: 600;
            font-size: 24px;
            line-height: 22px;
            color: #141823;
            text-align: center;
            margin-bottom:3rem;
    }

    & .art{
        display:flex;
        justify-content: center;
        margin-bottom:3rem;
    }

    & .close{
        width: 24px;
        height: 24px;
        position: absolute;
        top: -40px;
        right: 0px;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        cursor: pointer;
    }

    & .close:before{
        content: "";
        background: #fff;
        position: absolute;
        width: 24px;
        border: 2px solid #fff;
        transform: rotate(-45deg);
    }

    & .close:after{
        content: "";
        background: #fff;
        position: absolute;
        width: 24px;
        border: 2px solid #fff;
        transform: rotate(45deg);
    }

    & .gotBtn{
        width: 171px;
        height: 48px;
        border: none;
        outline: none;
        background: #D1E5FF;
        border-radius: 38px;
        color: #2276E3;
        font-family: 'Rubik';
        font-size: 18px;
        font-weight: 600;
        cursor: pointer;
        margin: 0 auto;
        margin-top:auto;
    }
`;